import styled from 'styled-components';
import Button from 'components/button';
import { IconAdd, IconBackFull, IconCards, IconKanban } from 'components/icons';
import { BG_KAMBAM_RECOLOCATION } from 'utils/CONSTANTS';
import CardUserJob from 'components/cards/user-job';
import ResponsiveContainer from 'components/container';

export const Card = styled(CardUserJob)``;

export const Responsive = styled(ResponsiveContainer)``;

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 0px;
  height: 100vh;
  background-color: #f9f9f9;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: 100%;
  overflow-x: scroll;
  padding: 0 0 0 55px;
`;

export const Header = styled.div`
  padding: 25px 55px 20px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grayUltraHigh};
  margin-bottom: 45px;
`;

export const HeaderBack = styled.a`
  margin-bottom: 107px;
`;

export const HeaderInfo = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
`;

export const HeaderActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: relative;
`;

export const HeaderTitle = styled.h2`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-family: ${({ theme }) => theme.fontFamily.inter.semiBold};
  font-size: 20px;
  margin: 0px;
`;

export const ModalSearch = styled.div`
  position: absolute;
  z-index: 999;
  padding: 15px 10px 0px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 16px 40px 0px #0000003d;
  border-radius: 0 0 7px 7px;
  left: 84px;
  top: 45px;
  width: 390px;
  max-height: 185px;
  overflow-y: scroll;
`;

export const SearchOption = styled.p`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-family: ${({ theme }) => theme.fontFamily.inter.regular};
  transition: color 350ms ease;
  margin: 0px 0px 15px;
  cursor: pointer;

  @media only screen and (min-width: 1024px) {
    &:hover {
      color: ${({ theme }) => theme.colors.secondary};
    }
  }
`

export const SwitchContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 20px;
  gap: 8px;
`;

export const SwitchLabel = styled.label`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.textSecondary};
  font-family: ${({ theme }) => theme.fontFamily.inter.regular};
  cursor: pointer;
`;

export const SwitchTrack = styled.div<{ $active: boolean }>`
  width: 40px;
  height: 22px;
  border-radius: 11px;
  background-color: ${({ theme, $active }) => $active ? theme.colors.secondaryDark : '#ccc'};
  position: relative;
  transition: background-color 300ms ease;
  cursor: pointer;
`;

export const SwitchThumb = styled.div<{ $active: boolean }>`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: white;
  position: absolute;
  top: 2px;
  transform: ${({ $active }) => $active ? 'translateX(20px)' : 'translateX(2px)'};
  transition: transform 300ms ease;
`;

export const AddConsultantButton = styled(Button).attrs({
  customStyle: { marginLeft: 40 },
})``;

export const KamBamTitle = styled.h4<{ id: number }>`
  color: ${({ theme }) => theme.colors.white};
  font-size: 16px;
  font-family: ${({ theme }) => theme.fontFamily.poppins} !important;
  border-radius: 5px; 
  padding: 12px !important;
  width: 100% !important;
  margin-bottom: 25px;
  background-color: ${({theme, id}) => BG_KAMBAM_RECOLOCATION[id] || theme.colors.blue} !important;
  cursor: pointer;
  transform: scale(1);
  transition: transform 350ms ease;


  @media only screen and (min-width: 1024px) {
    &:hover {
      transform: scale(1.05)
    }
  }
`;

// Cards
export const ClientsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: stretch;
  flex-wrap: wrap;
  padding-bottom: 50px;
`;

export const PaginationArea = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: stretch;
  margin-bottom: 50px;
`;

export const NextPageButton = styled(Button).attrs({
  customStyle: { marginLeft: 10, maxWidth: 30 },
})``;

export const PreviousPageButton = styled(Button).attrs({
  customStyle: { maxWidth: 40 },
})``;

export const LoadRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
`;


export const AddIcon = styled(IconAdd).attrs({
  width: 24,
  height: 24,
})`
  fill: none;
  margin-right: 10px;
`;

export const BackFullIcon = styled(IconBackFull).attrs({
  width: 74,
  height: 22,
})`
  color: #8f8f8f;
  fill: none;
  transition: color 350ms ease;
  @media only screen and (min-width: 1024px) {
    &:hover {
      color: ${({ theme }) => theme.colors.secondaryDark};
    }
  }
`;

export const KanbanIcon = styled(IconKanban).attrs<{$isActive: boolean;}>({
  width: 22,
  height: 22,
})`
  fill: ${({ theme, $isActive }) => $isActive ?  theme.colors.primaryDark :theme.colors.gray };
  transform: scale(1);
  transition: transform 350ms ease;
  margin-right: 20px;
  cursor: pointer;
  @media only screen and (min-width: 1024px) {
    &:hover {
      transform: scale(1.15);
    }
  }
`;

export const CardsIcon = styled(IconCards).attrs<{$isActive: boolean;}>({
  width: 22,
  height: 22,
})`
  fill: ${({ theme, $isActive }) => $isActive ?  theme.colors.primaryDark :theme.colors.gray };
  transform: scale(1);
  transition: transform 350ms ease;
  margin-right: 20px;
  cursor: pointer;
  @media only screen and (min-width: 1024px) {
    &:hover {
      transform: scale(1.15);
    }
  }
`;

